import React from 'react';
import AsaasPaymentScreen from '../../onboarding/components/AsaasPaymentScreen';

export const OnboardingWebViewPaymentPage: React.FC = () => {
  return <AsaasPaymentScreen variant="webview" />;
};

export default OnboardingWebViewPaymentPage;
